import { useSetState } from '@domain-group/react-hooks'

const defaultState = {
  dueDate: '',
  selectedUser: undefined,
}

const useManageTaskListItems = () => {
  const [state, setState] = useSetState(defaultState)
  const { dueDate, selectedUser } = state

  return {
    callbacks: {
      setState,
    },
    dueDate,
    selectedUser,
  }
}

export default useManageTaskListItems
